import { Injectable } from '@angular/core';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { BehaviorSubject } from 'rxjs';
import { LocalServiceService } from './shareModule/services/local-service.service';

@Injectable({
  providedIn: 'root'
})
export class FollowService {
  public followed = new BehaviorSubject([])
  public followedRecommendation  = new BehaviorSubject([])
  public followedFavorites  = new BehaviorSubject([])
  public followedRecommendedProducts  = new BehaviorSubject([])
  public followedHowTo  = new BehaviorSubject([])

  
  constructor(private auth: AuthServiceService, private local: LocalServiceService) {
     this.getFollowData()
    this.local.getUserDetailsObserver().subscribe((user)=>{
   
         this.getFollowData()
      
    })
   
  }

  public getFollowData(){
    if(!this.local.getUser()){
      this.followedFavorites.next([]);
      this.followedRecommendation.next([]);
      this.followedRecommendedProducts.next([]);
      this.followedHowTo.next([])
      return;
    }

    this.auth.getPostsOfFollowedAccounts().subscribe({
      next: data =>{
        this.followedFavorites.next(data.body.followedFavorites);
        this.followedRecommendation.next(data.body.followedRecommendation);
        this.followedRecommendedProducts.next(data.body.followedRecommendedProducts);
        this.followedHowTo.next(data.body.followedHowTo)

      }
    })
  }
}
